import BannerPanel from "../../../components/bannerPanel/bannerPanel";

import styles from "./headerBannerPanel.module.scss"

function HeaderBannerPanel({ blok, header_banner_panel }) {
  if(!header_banner_panel) { return null }
  const {link, desktop_image, mobile_image} = header_banner_panel

  return (
    <section className={`page-content ${styles.headerBannerPanel} ${blok?.margin_top ? styles.marginTopDefault : ""} ${blok?.margin_bottom ? styles.marginBottomDefault : ""}`}>
      <BannerPanel link={link} desktop_image={desktop_image} mobile_image={mobile_image} />
    </section>
  )
}

export default HeaderBannerPanel
